<template>
  <div>
    <vuex-breadcrumb></vuex-breadcrumb>
    <h1 id="jump-to-header">{{heading || "View"}}</h1>
    <profile-show :id="id"></profile-show>
    <actor-role-index
      :filtering="actor_filter"
      :refresh="refresh"
      @refreshed="refreshed"
    >
    </actor-role-index>
  </div>
</template>

<script>
import VuexBreadcrumb from './VuexBreadcrumb.vue'
import ProfileShow from './ProfileShow.vue'
import ActorRoleIndex from './ActorRoleIndex.vue'

export default {
  components: {
    VuexBreadcrumb,
    ProfileShow,
    ActorRoleIndex
  },
  props: {
    id: String,
    heading: {
      Type: String
    }
  },
  data() {
    return {
      actor_filter: {
        profile_ids: this.id
      },
      refresh: false
    }
  },
  methods: {
    refreshed() {
      this.refresh = false
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>